import { $getSelection, useLexicalComposerContext } from '@talentmesh/rte';
import { Button } from '@talentmesh/ui/components/button';
import React, { useCallback } from 'react';

export type Placeholder = { label: string; value: string };

interface PlaceholderPluginsProps {
    placeholders: Placeholder[];
}

const PlaceholderPlugins = ({ placeholders }: PlaceholderPluginsProps) => {
    const [editor] = useLexicalComposerContext();

    const handlePlaceholderClick = useCallback(
        (e: React.MouseEvent<HTMLButtonElement>) => {
            const placeholder = e.currentTarget.value;

            editor.update(() => {
                const selection = $getSelection();
                selection?.insertText(placeholder);
            });
        },
        [editor],
    );

    return placeholders.map(({ label, value }) => (
        <Button
            key={label}
            size="xs"
            type="button"
            variant="default-outline"
            className="bg-transparent"
            value={value}
            onClick={handlePlaceholderClick}
        >
            {label}
        </Button>
    ));
};

export default PlaceholderPlugins;
